<template>
    <div class="uploadImagePopup">
        <label :for="rnid" class="uploadArea d-flex justify-content-center align-items-center" @dragover.prevent
            @drop.stop.prevent="onDrop" @dragover="dragover" @dragleave="dragleave"
            :style="{ backgroundImage: `url(${url})` }">
            <span v-bind:class="{ 'borderedIcon': borderedicon }"><img src="images/dslr-camera.png" v-if="icon" class="img-fluid"></span>
            <span class="text" v-html="uploadtitle"> </span>
            <input type="file" :id="rnid" hidden ref="djfile" @change="onFileChange" v-validate="`${fileValidation}`"
                :name="filename" :data-vv-as="messagename" :multiple="max>1">
        </label>
        <!-- <p v-if="verrors.has(filename)" class="errormsg">{{ verrors.first(filename) }} </p> -->
    </div>
</template>

<script>
 export default {
     inject: ['$validator'],
     name: 'File-Dropzone',
     props: {
         initialValue: {

         },
         icon: {
             type: Boolean,
             default: false
         },
         borderedicon: {
             type: Boolean,
             default: false
         },
         max: {
             type: Number,
             default: 1
         },
         uploadtitle: {
             type: String,
             default: 'Click to upload'
         },
         filename: {
             type: String,
             default: 'file'
         },
         messagename: {
             type: String,
             default: function () {
                 return this.filename
             }
         },
         fileValidation: {
             type: String,
             default: ''
         },
     },
     data() {
         return {
             rnid: this.ran_inx(),
             url: this.initialValue ? this.set_image(this.initialValue) : null,
             file: ''
         }
     },
     watch: {
         async initialValue(n) {
             if (n === '' || n === null) {
                 this.url = null
                 this.file = ''
                 this.$refs.djfile.value = null;
             }
         }

     },
     computed: {},

     mounted() {},

     methods: {
         re_initial() {
             this.file = '';
             this.$refs.djfile.value = null;
             this.url = this.set_image(this.initialValue);
         },
         onFileChange() {
             if (this.max == 1) {
                 //this.file = event.target.files[0];
                 this.file = this.$refs.djfile.files[0]
                 this.url = this.file ? URL.createObjectURL(this.file) : null;
             } else {
                 this.file = this.$refs.djfile.files
             }

             this.$emit('changed', this.file);
         },
         onDrop(event) {

             event.currentTarget.classList.remove('bg-green-300');
             this.$refs.djfile.files = event.dataTransfer.files;
             /*
                          if(this.max==1){
                          const file = event.dataTransfer.files[0];
                          this.file = file;
                          this.url = URL.createObjectURL(this.file);
                          }else{
                              this.file = event.dataTransfer.files;
                          }
             */
             //console.log(this.file);

             this.onFileChange()
             // this.$emit('changed', this.file)
         },
         dragover(event) {
             event.preventDefault();
             // Add some visual fluff to show the user can drop its files
             if (!event.currentTarget.classList.contains('bg-green-300')) {
                 event.currentTarget.classList.remove('bg-gray-100');
                 event.currentTarget.classList.add('bg-green-300');
             }
         },
         dragleave(event) {
             // Clean up
             //event.currentTarget.classList.add('bg-gray-100');
             event.currentTarget.classList.remove('bg-green-300');
         },

     }
 };

</script>

<style scoped>
.bg-gray-100 {
    background-color: #888383;
}

.bg-green-300 {
    background-color: #13d369;
}
</style>
